// extracted by mini-css-extract-plugin
export default {"message":"Error_Screen_message__HmRih","email":"Error_Screen_email__D7goB"};